// Lib
import chroma from 'chroma-js';
import { Thunk } from '../../../../../types/reduxTypes';
import Immutable from 'immutable';

// Actions
import { getNewElementId } from '../../../../../element/actions/elementActions';
import { addRootToTag, createTag } from '../../../../../../common/tags/tagActions';

// Types
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { Tag, TagCreationData } from '../../../../../../common/tags/tagTypes';
import { getCurrentContextRootId } from './tagUtils';
import {
    addTagToElements,
    removeTagFromElements,
    replaceTagOnElements,
} from '../../../../../element/tags/elementTagActions';
import { getElements } from '../../../../../element/selectors/elementSelector';
import { getElement } from '../../../../../../common/elements/utils/elementTraversalUtils';

export const createNewTagThunk =
    (tagData: TagCreationData): Thunk<Tag> =>
    (dispatch: Function) => {
        const id = dispatch(getNewElementId());

        const { name, creator, rootBoardIds, color } = tagData;
        const tag = {
            id,
            name,
            rootBoardIds,
            color: color || chroma.random().hex(),
            meta: {
                creator,
                createdTime: Date.now(),
                modifiedTime: Date.now(),
            },
        };

        dispatch(createTag(tag));
        return tag;
    };

export const addTagToElementsThunk =
    (tag: Tag, elements: Immutable.List<ImMNElement>, currentBoardId: string, shareRootPath: ImMNElement[]): Thunk =>
    (dispatch: Function) => {
        if (!getCurrentContextRootId(tag, shareRootPath)) {
            dispatch(addRootToTag(tag, currentBoardId));
        }

        dispatch(addTagToElements(elements, tag.id));
    };

export const createAndAddTagToElementsThunk =
    (
        tagData: TagCreationData,
        elements: Immutable.List<ImMNElement>,
        currentBoardId: string,
        shareRootPath: ImMNElement[],
    ): Thunk =>
    (dispatch: Function) => {
        const newTag = dispatch(createNewTagThunk(tagData));
        dispatch(addTagToElementsThunk(newTag, elements, currentBoardId, shareRootPath));
    };

export const replaceTagIdForElementsThunk =
    (elementIds: string[], oldTagId: string, newTagId?: string): Thunk =>
    (dispatch: Function, getState: Function) => {
        const state = getState();
        const elements = getElements(state);

        const updatingElements = Immutable.List(elementIds.map((id) => getElement(elements, id)));
        if (!updatingElements || updatingElements.size === 0) return;

        if (!newTagId) {
            // If no new tag id is provided, we are just removing the old tag from the elements
            return dispatch(removeTagFromElements(updatingElements, oldTagId));
        }

        dispatch(replaceTagOnElements(updatingElements, oldTagId, newTagId));
    };
